import { render, staticRenderFns } from "./DropDownMenu.vue?vue&type=template&id=31fac509&scoped=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"
import style0 from "./DropDownMenu.vue?vue&type=style&index=0&id=31fac509&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fac509",
  null
  
)

export default component.exports